var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.custom = exports.error = exports.success = exports.warning = exports.info = void 0;
const events_1 = require("./events");
const getUUID_1 = __importDefault(require("../getUUID"));
/**
 * @param content can be `string | JSX.Element`
 */
function info(content, options) {
    return internalAddToasty('info', content, options);
}
exports.info = info;
/**
 * @param content can be `string | JSX.Element`
 */
function warning(content, options) {
    return internalAddToasty('warning', content, options);
}
exports.warning = warning;
/**
 * @param content can be `string | JSX.Element`
 */
function success(content, options) {
    return internalAddToasty('success', content, options);
}
exports.success = success;
/**
 * @param content can be `string | JSX.Element`
 */
function error(content, options) {
    return internalAddToasty('error', content, options);
}
exports.error = error;
/**
 * @param content can be `string | JSX.Element`
 */
function custom(content, options) {
    return internalAddToasty('custom', content, options);
}
exports.custom = custom;
function internalAddToasty(type, content, options) {
    const toasty = Object.assign(Object.assign({ content }, getDefaultedOptions(options)), { type });
    (0, events_1.addToasty)(toasty);
    return () => (0, events_1.hideToasty)(toasty);
}
function getDefaultedOptions(options) {
    const opts = Object.assign({}, options);
    if (!opts.id) {
        opts.id = (0, getUUID_1.default)();
    }
    if (!opts.manuallyHide && !opts.duration) {
        opts.duration = 3800;
    }
    return opts;
}
//# sourceMappingURL=index.js.map